import { render, staticRenderFns } from "./ztSliderItem.vue?vue&type=template&id=6ca59037&scoped=true"
import script from "./ztSliderItem.vue?vue&type=script&lang=js"
export * from "./ztSliderItem.vue?vue&type=script&lang=js"
import style0 from "../../../../../src/styles/components/ztSlider.css?vue&type=style&index=0&id=6ca59037&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca59037",
  null
  
)

export default component.exports